import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import MarkdownRenderer from "../../MarkdownRenderer";
import styles from "../agent-response.module.scss";

type QAAgentProps = {
  parsedContent: any;
};

export default function QAAgent({
  parsedContent,
}: QAAgentProps): JSX.Element {
  // Parse the answer field (it's a JSON string)
  const answer =
    typeof parsedContent?.answer === "string"
      ? safeJSONParse(parsedContent.answer)
      : parsedContent?.answer || {};

  const answerText = answer?.answer || "";
  const question = parsedContent?.question || parsedContent?.prompt;

  return (
    <div
      style={{
        lineHeight: "1.6",
        color: "#333",
      }}
    >
      {/* Answer Section */}
      {answerText && (
        <div
          style={{
            fontSize: "14px",
            color: "#403f3f",
            marginBottom: "20px",
          }}
        >
          <MarkdownRenderer content={answerText} />
        </div>
      )}

      {/* Question Section */}
      {question && <div className={styles.finalQuestion}>{question}</div>}
    </div>
  );
}
